import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

@Component({
  selector: 'app-candidate-conference',
  templateUrl: './candidate-conference.component.html',
  styleUrls: ['./candidate-conference.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CandidateConferenceComponent implements OnInit {
  @Input() scheduleId: any;
  @Input() candidateId: any;
  @Input() jobId: any;
  @Input() jobMatchId: any;
  @Input() workflowStep: any;
  @Input() participantType: any;
  @Input() type: any;
  @Input() mode: any;
  @Output() loaded = new EventEmitter<void>();

  isLoading: boolean;
  scheduleInfo: any;
  showSEBInstructions: boolean;
  isRunningInSEB: boolean;
  workflowStepName: string;
  sebDownloadUrl: string;
  sebInfoUrl: string;
  sebConfigUrl: string;

  constructor(
    private meetingService: MeetingService,
    private alertsAndNotificationsService: AlertAndNotificationsService) { }

  ngOnInit() {
    this.isLoading = true;
    this.showSEBInstructions = true;
    this.workflowStepName = this._getWorkflowStepName();

    this.isRunningInSEB = this._detectSEB();
    this.sebDownloadUrl = 'https://safeexambrowser.org/download_en.html';
    this.sebInfoUrl = 'https://safeexambrowser.org/about_overview_en.html';
    this.sebConfigUrl = this.meetingService.getSebConfigurationFileUrl({
      candidateId: this.candidateId,
      meetingScheduleId: this.scheduleId,
      mode: this.mode,
      workflowStep: this.workflowStep
    });

    // Load schedule/meeting details up front so the instructions screen can tell the
    // candidate what they're actually joining (Recruiter Screening / Phone Screen / Interview).
    this._getScheduleDetails();

    // If already running inside SEB, skip instructions and load directly
    if (this.isRunningInSEB) {
      this.showSEBInstructions = false;
    }
  }

  _getWorkflowStepName() {
    if (this.workflowStep === 'ps') {
      return 'Phone Screen';
    } else if (this.workflowStep === 'in') {
      return 'Interview';
    } else if (this.workflowStep === 'rs') {
      return 'Recruiter Screening';
    }
    return '';
  }

  _detectSEB() {
    const ua = (navigator && navigator.userAgent) ? navigator.userAgent : '';
    return /SafeExamBrowser/i.test(ua) || /\bSEB\b/.test(ua);
  }

  attemptTest() {
    if (this.isRunningInSEB) {
      // Already in SEB and schedule details are already loaded — just reveal the conference
      this.showSEBInstructions = false;
    } else {
      // Convert the .seb config URL to the SEB custom protocol (seb:// / sebs://).
      // The browser hands off to SEB directly (no download prompt).
      // SEB fetches config file from the URL, applies all restrictions,
      // then opens the startURL defined inside that config.
      window.location.href = this._toSEBProtocol(this.sebConfigUrl);

      // When SEB launches it takes OS focus, causing the browser window to blur.
      // Track that blur event as a reliable signal that SEB was handed off successfully.
      let sebHandedOff = false;
      const onBlur = () => {
        sebHandedOff = true;
        window.removeEventListener('blur', onBlur);
      };
      window.addEventListener('blur', onBlur);

      // After 2.5s, if neither blur nor page-hide fired, SEB is not installed.
      setTimeout(() => {
        window.removeEventListener('blur', onBlur);
        if (!sebHandedOff && !document.hidden) {
          this.alertsAndNotificationsService.showAlert(
            'Safe Exam Browser (SEB) is not installed on this system.',
            'Please complete Step 1 and Step 2 to install it before attempting the test.',
            'danger'
          );
        }
      }, 2500);
    }
  }

  // Resolves a relative path to a full URL, then swaps the scheme to seb:// / sebs://
  // so the OS launches SEB directly via its registered protocol handler.
  _toSEBProtocol(path) {
    const fullUrl = new URL(path, window.location.href).href;
    return fullUrl
      .replace(/^https:\/\//i, 'sebs://')
      .replace(/^http:\/\//i, 'seb://');
  }

  _getScheduleDetails() {
    this.meetingService.getScheduleDetails(this.scheduleId, (data) => {
      this.scheduleInfo = this.meetingService.getMassagedMeetingDetails(data);
      if (this.jobId && this.jobId == "") {
        this.jobId = data.jobId;
      }
      this.isLoading = false;
      this.loaded.emit();
    }, error => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
      this.isLoading = false;
      this.loaded.emit();
    });
  }
}
